/**
 * SYSTEM SETTINGS MODULE
 * The customer's company setup — per-tenant master/reference data (Product SKUs,
 * States / Distributors / Regions) that multiple product modules consume
 * (sales-forecasting today). Gated to the workspace owner/admin.
 *
 * Distinct from Account settings (personal/user) and from the platform /admin
 * (Brand Command staff). Reference data is read/written through
 * shared/referenceDataService, so any module reads the same source of truth
 * (module -> shared is allowed; modules never read each other).
 *
 * Public entry. Registered in App.jsx via
 * registerModule(systemSettingsRoutes, { roles: ['workspace_admin'] }).
 */

import SystemSettings from "./routes/SystemSettings.jsx";

export const systemSettingsRoutes = [
  { path: "/system-settings", component: SystemSettings },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "system-settings", label: "System Settings" };
